import Decimal from 'decimal.js';

import { ChargeKey, Charges } from '../types';

export const getChargeAmount = (charges: Charges, key: ChargeKey) =>
  charges?.[key]?.amount || 0;

// Copying sum function of `useGetOfferCharges.js`
export const sumChargeAmounts =
  (...charges: Charges[]) =>
  (key: ChargeKey) =>
    charges.reduce((acc, charges) => {
      const amount = getChargeAmount(charges, key);
      const sum = Decimal.add(acc, amount);
      return sum.toNumber();
    }, 0);
